import React from 'react';

import {HttpMonitorUnsubscribeScreen} from 'features/http';

const HttpMonitorUnsubscribePage: React.FC = () => {
    return <HttpMonitorUnsubscribeScreen/>;
};

export default HttpMonitorUnsubscribePage;
